import AddNew from "./AddNew";
import List from "./List";

export default function Drivers() {
    return (
        <>
            <AddNew/>
            <List/>
        </>
    )
}
